import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { GlobalApplicationState } from "globalApplicationState";

import Button from "@mui/material/Button";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import TopicGroupCreation from "./dialogs/topicGroupCreation";
import TopicCreation from "./dialogs/topicCreation";
import { getRole } from "utils/getRole";
import { getHighestRole } from "utils/userRoleUtils";
import { UserRoleStrings } from "modules/authorization/models";

const AddTopic: React.FunctionComponent<PropsWithRedux> = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showTopicGroupDialog, setShowTopicGroupDialog] = React.useState(false);
    const [showTopicDialog, setShowTopicDialog] = React.useState(false);

    const open = Boolean(anchorEl);

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const topicGroupClick = () => {
        setShowTopicGroupDialog(true);
    };

    const closeTopicGroupDialog = () => {
        setShowTopicGroupDialog(false);
    };

    const topicClick = () => {
        setShowTopicDialog(true);
    };
    
    const closeTopicDialog = () => {
        setShowTopicDialog(false);
    };

    return (
        <React.Fragment>
            <Button
                disabled={!props.canEdit}
                variant="contained"
                color="primary"
                endIcon={<ArrowDropDownIcon />}
                onClick={handleClick}
            >
                Add new
            </Button>
            <Menu
                id="add-menu"
                anchorEl={anchorEl}
                open={open}
                onClick={handleClose}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'add-button',
                }}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                slotProps={{
                    paper: {
                        style: {
                            transform: 'translateY(6px)',
                        }
                    }
                }}
            >
                <MenuItem onClick={topicGroupClick}>Topic Group</MenuItem>
                <MenuItem onClick={topicClick}>Topic</MenuItem>
            </Menu>
            <TopicGroupCreation show={showTopicGroupDialog} onClose={closeTopicGroupDialog} />
            <TopicCreation show={showTopicDialog} onClose={closeTopicDialog} />
        </React.Fragment>
    );
};

interface ComponentProps {
}

const connector = connect(
    (state: GlobalApplicationState, ownProps: ComponentProps) => ({
        ...ownProps,
        canEdit: isTopicEditable(state),
    })
);

const isTopicEditable = (state: GlobalApplicationState) =>
    getHighestRole(state.settings.currentUser) === UserRoleStrings.OWNER &&
    state.settings.tenantSettings.manageTopicsAudiencesInAdmin &&
    !state.settings.saving &&
    (state.insights.topChannels || state.settings.tenantSettings);

type PropsWithRedux = ConnectedProps<typeof connector>;

export default connector(AddTopic);